import React from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * SetupStatusLoader — shown while /api/auth/status is being checked.
 */
export function SetupStatusLoader() {
  return (
    <div className="auth-page">
      <div className="auth-page-grid" />
      <div className="auth-shell">
        <div className="auth-card" style={{ textAlign: 'center', padding: 36 }}>
          <RefreshCw
            size={28}
            color="var(--brand-blue)"
            style={{ animation: 'spin 0.8s linear infinite', marginBottom: 12 }}
          />
          <div style={{ color: 'var(--auth-text-muted)', fontSize: 12, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
            Checking system status…
          </div>
        </div>
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg);}}`}</style>
    </div>
  );
}
